import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { fetchMyPrivacy, identityKeys } from '@/lib/queries/identity';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { EmailClient } from './-components/EmailClient';

export const Route = createFileRoute('/_authed/settings/email/')({
  component: SettingsEmailPage,
});

function SettingsEmailPage() {
  const query = useQuery({
    queryKey: identityKeys.privacy(),
    queryFn: fetchMyPrivacy,
    retry: false,
  });
  if (query.isError) {
    return (
      <SettingsErrorShell
        title="Email preferences"
        message="Could not load email preferences."
      />
    );
  }
  if (query.isLoading) return null;
  return <EmailClient />;
}
